 
import React, { forwardRef, useState, useEffect } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { MaskedInput } from '@thaborach/react-text-mask';
import Tooltip from 'v3/components/Tooltip';
import theme from 'v3/theme';
import { FaRegClock, FaCalendarAlt } from "react-icons/fa";

import {
  Input,
  Container,
  ContainerInside,
  IconSpace,
  RightIcon,
  ErrorText,
  Label,
} from './styles';
import Loader from '../Loader';

function StyledInput(
  {
    defaultValue,
    label,
    labelSize = null,
    labelWhiteSpace = 'normal',
    labelColor = '#464e5f',
    placeholderSize = '14px',
    type,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    icon,
    rightIcon,
    error,
    masked,
    guide,
    mask = [],
    containerStyle,
    containerInsideStyle,
    inputAs,
    rightIconColor = '#e5eaee',
    rightIconAction,
    tooltip = '',
    IconSpaceColor = '#e5eaee',
    fontSize = '0.875rem',
    fontColor = '#494950',
    loading = false,
    disabled = false,
    timeInterval = 60,
    hideAppearance,
    ...rest
  },
  ref,
) {

  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (ref?.current) {
      ref.current.value = rest.value || '';
    }
  }, [rest.value]);

  function handleFocus() {
    setFocus(true);

    if (onFocus) {
      onFocus();
    }
  }


  if (type === 'year') {
    const currentYear = new Date().getFullYear();
    const startYear = rest.minYear || 1970;
    const endYear = rest.maxYear || currentYear + 5;

    const years = [];
    for (let y = endYear; y >= startYear; y--) {
      years.push(String(y));
    }

    return (
      <Container style={containerStyle}>
        {label && (
          <Label
            labelColor={labelColor}
            type="label"
            weight="500"
            labelWhiteSpace={labelWhiteSpace}
          >
            {label}
          </Label>
        )}

        <div style={{ position: 'relative', width: '100%' }}>
          <ContainerInside
            style={{
              ...containerInsideStyle,
              width: '100%',
              position: 'relative',
              cursor: 'pointer',
            }}
            onClick={() => !disabled && setOpen(prev => !prev)}
          >
            <Input
              as="div"
              focus={focus}
              error={error}
              disabled={disabled}
              style={{
                padding: '10px 40px 10px 12px',
                height: '44px',
                lineHeight: '24px',
                width: '100%',
                backgroundColor: disabled ? '#f5f5f5' : '#fff',
                color: rest.value ? '#464e5f' : theme.colors.placeholder,
              }}
            >
              {rest.value || placeholder || 'Selecione o ano'}
            </Input>

            <RightIcon
              as="div"
              rightIconColor="#f3f6f9"
              style={{
                position: 'absolute',
                right: '0',
                top: '0',
                height: '100%',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '0 5px 5px 0',
              }}
            >
              <FaCalendarAlt size={18} color={theme.colors.primary || '#3699FF'} />
            </RightIcon>
          </ContainerInside>

          {open && (
            <div
              style={{
                position: 'absolute',
                top: '105%',
                left: 0,
                width: '100%',
                background: 'white',
                border: '1px solid #e5eaee',
                borderRadius: '5px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 9999,
              }}
            >
              {years.map(year => (
                <div
                  key={year}
                  onClick={e => {
                    e.stopPropagation();
                    onChange({ target: { value: year } });
                    setOpen(false);
                  }}
                  style={{
                    padding: '10px 12px',
                    cursor: 'pointer',
                    backgroundColor:
                      rest.value === year ? '#e9f3ff' : 'transparent',
                    color: '#464e5f',
                    textAlign: 'center',
                  }}
                  onMouseEnter={e =>
                    (e.currentTarget.style.backgroundColor = '#f3f6f9')
                  }
                  onMouseLeave={e =>
                    (e.currentTarget.style.backgroundColor =
                      rest.value === year ? '#e9f3ff' : 'transparent')
                  }
                >
                  {year}
                </div>
              ))}
            </div>
          )}
        </div>

        {error && (
          <ErrorText color="error" type="little">
            {error}
          </ErrorText>
        )}
      </Container>
    );
  }

  if (type === 'time-interval') {

    const interval = timeInterval;

    const options = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += interval) {
        const hh = String(h).padStart(2, '0');
        const mm = String(m).padStart(2, '0');
        options.push(`${hh}:${mm}`);
      }
    }

    return (
      <Container style={containerStyle}>
        {label && (
          <Label
            $labelColor={labelColor}
            type="label"
            weight="500"
            $labelWhiteSpace={labelWhiteSpace}
          >
            {label}
          </Label>
        )}

        <div style={{ position: 'relative' }}>
          <ContainerInside
            style={{
              ...containerInsideStyle,
              position: 'relative',
              cursor: 'pointer',
            }}
            onClick={() => !disabled && setOpen(prev => !prev)}
          >
            <Input
              as="div"
              $focus={focus}
              $error={error}
              $hideAppearance={hideAppearance}
              disabled={disabled}
              style={{
                padding: '10px 40px 10px 12px',
                height: '44px',
                lineHeight: '24px',
                backgroundColor: disabled ? '#f5f5f5' : '#fff',
              }}
            >
              {rest.value}
            </Input>

            <RightIcon
              as="div"
              $rightIconColor="#f3f6f9"
              style={{
                position: 'absolute',
                right: '0',
                top: '0',
                height: '100%',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '0 5px 5px 0',
              }}
            >

              <FaRegClock size={18} color={theme.colors.primary || '#3699FF'} />

            </RightIcon>
          </ContainerInside>

          {open && (
            <div
              style={{
                position: 'absolute',
                top: '105%',
                left: 0,
                width: '100%',
                background: 'white',
                border: '1px solid #e5eaee',
                borderRadius: '5px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                maxHeight: '300px',
                overflowY: 'auto',
                zIndex: 9999,
              }}
            >
              {options.map(time => (
                <div
                  key={time}
                  onClick={e => {
                    e.stopPropagation();
                    onChange({ target: { value: time } });
                    setOpen(false);
                  }}
                  style={{
                    padding: '10px 12px',
                    cursor: 'pointer',
                    backgroundColor:
                      rest.value === time ? '#e9f3ff' : 'transparent',
                    color: '#464e5f',
                  }}
                  onMouseEnter={e =>
                    (e.currentTarget.style.backgroundColor = '#f3f6f9')
                  }
                  onMouseLeave={e =>
                  (e.currentTarget.style.backgroundColor =
                    rest.value === time ? '#e9f3ff' : 'transparent')
                  }
                >
                  {time}
                </div>
              ))}
            </div>
          )}
        </div>

        {error && (
          <ErrorText color="error" type="little">
            {error}
          </ErrorText>
        )}
      </Container>
    );
  }

  if (masked)
    return (
      <Container style={containerStyle}>
        {label && (
          <div className="w-100">
            <Label
              $labelColor={labelColor}
              type="label"
              weight="500"
              $labelWhiteSpace={labelWhiteSpace}
              $labelSize={labelSize}
            >
              {label}
            </Label>
            {tooltip.length > 0 && (
              <Tooltip
                content={
                  <Label type="label" color="white">
                    {tooltip}
                  </Label>
                }
              >
                <FaQuestionCircle
                  className="ml-2 mt-1"
                  style={{ color: theme.colors.light_blue }}
                />
              </Tooltip>
            )}
          </div>
        )}
        {loading ? (
          <Loader loading={loading} />
        ) : (
          <>
            <ContainerInside style={containerInsideStyle}>
              {icon && <IconSpace $IconSpaceColor={IconSpaceColor}>{icon}</IconSpace>}
              <MaskedInput
                defaultValue={defaultValue}
                mask={mask}
                guide={guide}
                onChange={onChange}
                onBlur={onBlur}
                render={(r, props) => (
                  <Input
                    $focus={focus}
                    $error={error}
                    $hideAppearance={hideAppearance}
                    disabled={disabled}
                    onFocus={handleFocus}
                    {...rest}
                    $fontSize={fontSize}
                    $fontColor={fontColor}
                    placeholder={placeholder}
                    $placeholderSize={placeholderSize}
                    onChange={onChange}
                    ref={(inputElement) => {
                      if (inputElement) {
                        if (r) {
                          r(inputElement);
                        }

                        if (ref) {
                          ref.current = inputElement;
                        }
                      }
                    }}
                    type={type}
                    {...props}
                    autoComplete="new-password"
                  />
                )}
              />
              {rightIcon && <RightIcon>{rightIcon}</RightIcon>}
            </ContainerInside>
            {error && (
              <ErrorText color="error" type="little">
                {error}
              </ErrorText>
            )}
          </>
        )}
      </Container>
    );

  return (
    <Container style={containerStyle}>
      {label && (
        <div className="w-100" style={{ display: tooltip?.length > 0 ? 'flex' : '' }}>
          <Label
            $labelColor={labelColor}
            type={labelSize ? null : "label"}
            weight="500"
            style={{ display: 'block' }}
            $labelWhiteSpace={labelWhiteSpace}
            $labelSize={labelSize}
          >
            {label}
          </Label>
          {tooltip.length > 0 && (
            <Tooltip
              content={
                <Label type="label" color="white">
                  {tooltip}
                </Label>
              }
            >
              <FaQuestionCircle className="ml-2 mt-1" style={{ color: theme.colors.light_blue }} />
            </Tooltip>
          )}
        </div>
      )}
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <>
          <ContainerInside style={containerInsideStyle}>
            {icon && <IconSpace $IconSpaceColor={IconSpaceColor}>{icon}</IconSpace>}
            <Input
              {...rest}
              ref={ref}
              disabled={disabled}
              defaultValue={defaultValue}
              $focus={focus}
              $error={error}
              $hideAppearance={hideAppearance}
              onFocus={handleFocus}
              placeholder={placeholder}
              onChange={onChange}
              onBlur={onBlur}
              type={type}
              as={inputAs}
              autoComplete="new-password"
              $fontSize={fontSize}
              $fontColor={fontColor}
            />
            {rightIcon && (
              <RightIcon onClick={rightIconAction} $rightIconColor={rightIconColor}>
                {rightIcon}
              </RightIcon>
            )}
          </ContainerInside>
          {error && (
            <ErrorText color="error" type="little">
              {error}
            </ErrorText>
          )}
        </>
      )}
    </Container>
  );
}

export default forwardRef(StyledInput);
